const WebService = {
   login: process.env.VUE_APP_API_ROOT + '/oauth/token',
   changePassword: process.env.VUE_APP_API_ROOT + '/api/changePassword',
   authUser: process.env.VUE_APP_API_ROOT + '/api/me',
   
   vendor: process.env.VUE_APP_API_ROOT + '/api/vendor',
   vendorContact: process.env.VUE_APP_API_ROOT + '/api/vendorContact',

   product: process.env.VUE_APP_API_ROOT + '/api/product',
   productCategory: process.env.VUE_APP_API_ROOT + '/api/productCategory',

   project: process.env.VUE_APP_API_ROOT + '/api/project',
   vendorproject: process.env.VUE_APP_API_ROOT + '/api/vendorproject',
   vendorprojectHistory: process.env.VUE_APP_API_ROOT + '/api/vendorprojectHistory',

   samplestock: process.env.VUE_APP_API_ROOT + '/api/samplestock',

   user: process.env.VUE_APP_API_ROOT + '/api/user',
   role: process.env.VUE_APP_API_ROOT + '/api/role',
   permission: process.env.VUE_APP_API_ROOT + '/api/permission',

}
export default WebService;